import React from "react";
import { InfiniteScroll } from "nq-component";
import RecentActivitiesPresenter from "./RecentActivitiesPresenter";
import BaseListPage from "../../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import CardView from "../../../../../components/common/CardView";
import Table from "../../../../../components/Table";
import withRouter from "../../../../../withRouter";
import NavBar from "../../../../../components/navigation";
import { formatDate } from "../../../../../components/common/Converter";
import Progress from "../../../../../components/Progress";

class RecentActivities extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new RecentActivitiesPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      count: 0,
      limit: 50,
      current: 1,
    };
  }

  //   async componentDidMount() {
  //     await this.presenter.componentDidMount();
  //     const employeeID = this.getCurrentUser().employee;
  //     const employee = await findObjectUseCase().execute("employees", {
  //       where: {
  //         id: employeeID.id,
  //       },
  //     });
  //     const date = formatDate(new Date().toISOString());

  //     const present = await findObjectUseCase().execute(
  //       this.getCollectionName(),
  //       {
  //         where: {
  //           user: employee[0].email,
  //           createdAt: { $gte: date },
  //         },
  //       }
  //     );
  //     console.log("PRES:L ", present);
  //     this.setState({ count: present.length });
  //   }
  getCollectionName() {
    return "audit_logs";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  createAllowances() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, current, count, limit } = this.state;
    if (!schema) return <Progress />;
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Activities
                </p>
              </div>

              <Table
                progress={loading}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "createdAt", "updatedAt", "serviceReq"]
                )}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(RecentActivities);
